// @flow

import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { imagePath } from 'frontend_core/dist/helpers/image'

const DateTitle = styled.p`
  font-size: ${fontSize.small_3}px;
  color: ${Colors.black};
  font-weight: bold;
`
const Date = styled.p`
  margin-top: ${spacing.small_3}px;
  font-size: ${fontSize.small_3}px;
  color: ${Colors.black};
  line-height: 1.285;
  ${({ hasChanged }) =>
    hasChanged &&
    css`
      color: ${Colors.grayB};
      text-decoration: line-through;
      margin-bottom: 6px;
    `};
`

export type PropTypes = {
  prevDateText?: ?string,
  dateText: string,
}

export default function ReservationDate(props: PropTypes) {
  return (
    <Fragment>
      <DateTitle>{i18n.t('page.dashboard.reservation.dayAndTime')}</DateTitle>
      {props.prevDateText && <Date hasChanged>{props.prevDateText}</Date>}
      <Date>{props.dateText}</Date>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationDate/index.jsx